import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
  'sfx': '',
};

export const techniciansAssignment = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_TECHNICIANS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TECHNICIANS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_TECHNICIANS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.FETCHED_TASKS_BY_ORDER]: (state, action) => ({
      ...state,
      'sfx': action.response.sfx,
    }),
    [ActionTypes.FETCHED_TASKS_BY_ORDER_FAILED]: (state, action) => ({
      ...state,
      'sfx': '',
    }),
  })(state, action);
};
